import React, { useState, useEffect } from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import axios from 'axios';
import Swal from 'sweetalert2';
import '../studiesPage/studyPage.css'
import { Link } from 'react-router-dom';


const SponsorStudy = ({ setShowSpinner }) => {
  const [allStudies, setAllStudies] = useState([])

  const getData = () => {
    setShowSpinner(true);
    const url = `https://research-mate-b35a10757d5a.herokuapp.com/api/sponsorStudy`;
    axios.get(url, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(res => {
        setAllStudies(res.data.data)
      })
      .catch(error => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.response.data.message,
          customClass: {
            container: 'swal2-container-custom'
          }
        });
      })
    setShowSpinner(false);
  }

  useEffect(() => {
    getData()
  }, [])
  return (
    <>
      <div className='p-2'>
      <h4 style={{color:'rgb(23 131 131)'}}>Sponsor Studies</h4>
  <div className='d-flex justify-content-center align-items-center'>
    {/* Conditionally render the "No Data" image */}
    {allStudies.length < 1 ? (
      <img width={500} height={500} src={require('../../images/nodataImg.webp')} alt="No Data Available" />
    ) : (
      <div className='main-card'>
        {/* Render the list of studies */}
        {allStudies.map((v, i) => {
          return (
            <Card className='mt-2' key={v._id}>
              <Card.Body>
                <Row>
                  <Col>
                    <h6>Study Code</h6>
                    <Link style={{ textDecoration: "none" }} to={`/readSponsorForm/${v._id}`}>
                      <p>{v.studyCode}</p>
                    </Link>
                  </Col>
                  <Col>
                    <h6>Study Title</h6>
                    <p>{v.title}</p>
                  </Col>
                  <Col>
                    <h6>Sponsor/CRO</h6>
                    <p>{v.sponsorName}</p>
                  </Col>
                  <Col>
                    <h6>Active Date</h6>
                    <p>{v.activationDate}</p>
                  </Col>
                  <Col>
                    <h6>Therapeutic Areas</h6>
                    <p>{v.therapeuticAreas}</p>
                  </Col>
                  <Col>
                    <h6>Phone #</h6>
                    <p>{v.phone}</p>
                  </Col>
                  <Col>
                    <h6>Email</h6>
                    <p>{v.email}</p>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          )
        })}
      </div>
    )}
  </div>
</div>

      {/* <div className='p-2'>
        <div className='d-flex justify-content-center align-items-center'>
      <img width={500} height={500} src={require('../../images/nodataImg.webp')} ></img>
        </div>
        <div className='main-card'>
          {
          allStudies.map((v, i) => {
            return (

              <Card className='mt-2' key={v._id} >
                <Card.Body>
                  <Row>
                    <Col>
                      <h6>Study Code</h6>
                      <Link style={{ textDecoration: "none" }} to={`/readSponsorForm/${v._id}`}>
                        <p>{v.studyCode}</p>
                      </Link>
                    </Col>
                    <Col>
                      <h6>Study Title</h6>
                      <p>{v.title}</p>

                    </Col>
                    <Col>
                      <h6>Sponsor/CRO</h6>
                      <p>{v.sponsorName}</p>

                    </Col>
                    <Col>
                      <h6>Active Date</h6>
                      <p>{v.activationDate}</p>

                    </Col>
                    <Col>
                      <h6>Therapeutic Areas</h6>
                      <p>{v.therapeuticAreas}</p>

                    </Col>
                    <Col>
                      <h6>Phone #</h6>
                      <p>{v.phone}</p>

                    </Col>
                    <Col>
                      <h6>Email</h6>
                      <p>{v.email}</p>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            )
          })}


        </div>
      </div> */}
    </>
  );
};

export default SponsorStudy;
